// hu-sticky-atc.js
(() => {
  const bar = document.querySelector('.hu-sticky-atc');
  if (!bar) return;

  const btn = bar.querySelector('[data-hu-sticky-atc-btn]');
  const priceEl = bar.querySelector('[data-hu-sticky-atc-price]');
  const form = document.querySelector('form[action^="/cart/add"]');
  const mainSubmitBtn = document.querySelector('.product-form__submit');

  if (!btn || !priceEl || !form || !mainSubmitBtn) return;

  // Show/hide bar when main ATC button is out of view
  const io = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (!entry) return;
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    },
    { threshold: 0.1 }
  );
  io.observe(mainSubmitBtn);

  // Keep variant id updated (Dawn fires variant:change)
  const setVariant = (variant) => {
    if (!variant || !variant.id) return;
    bar.dataset.variantId = String(variant.id);
    if (typeof variant.available !== 'undefined') {
      btn.disabled = !variant.available;
      btn.setAttribute('aria-disabled', String(!variant.available));
    }
    if (variant.price) priceEl.textContent = variant.price;
  };

  document.addEventListener('variant:change', (e) => {
    const v = e?.detail?.variant;
    if (!v) return;

    // Try to format price if Dawn provides price in cents
    if (typeof v.price === 'number') {
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: (bar.dataset.currency || 'EUR'),
      });
      setVariant({ ...v, price: formatter.format(v.price / 100) });
    } else {
      setVariant(v);
    }
  });

  // Add to cart via Shopify endpoint
  btn.addEventListener('click', async () => {
    const variantId = bar.dataset.variantId || bar.getAttribute('data-initial-variant-id');
    if (!variantId) return;

    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!res.ok) throw new Error('add_failed');

      // Simple & reliable: open cart page (works in every Dawn setup)
      window.location.href = '/cart';
    } catch (err) {
      btn.disabled = false;
      alert('Konnte nicht in den Warenkorb legen. Bitte nochmal versuchen.');
    }
  });
})();
